import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";

import { useDeferredReady } from "../hooks/useDeferredReady";

import LoadingSpinner from "@/components/LoadingSpinner";

export const DeferredDiffViewer = ({
  oldValue,
  newValue,
}: {
  oldValue: string;
  newValue: string;
}) => {
  const isReady = useDeferredReady();

  if (!isReady) {
    return (
      <div className="flex items-center justify-center px-4 py-6">
        <LoadingSpinner size={4} />
        <span className="ml-2 text-xs text-gray-500">Computing diff...</span>
      </div>
    );
  }

  return (
    <ReactDiffViewer
      oldValue={oldValue}
      newValue={newValue}
      splitView
      hideLineNumbers
      showDiffOnly={false}
      extraLinesSurroundingDiff={2}
      compareMethod={DiffMethod.WORDS}
    />
  );
};
